<template>
  <div class="col">
    <div
      v-if="isAuthenticated"
      class="top row menu-row"
    >
      <div
        class="menu-item hover-shadow"
        @click="goToAdmin"
      >
        <div class="text">
          Admin
        </div>
      </div>
      <div
        class="menu-item hover-shadow"
        @click="goToMyCollection"
      >
        <div class="text">
          Ma collection
        </div>
      </div>
      <div
        class="menu-item hover-shadow"
        @click="goToSearchByCountry"
      >
        <div class="text">
          Recherche par pays
        </div>
      </div>
      <div
        class="menu-item hover-shadow"
        @click="goToSearchById"
      >
        <div class="text">
          Recherche par ID
        </div>
      </div>
    </div>
    <div
      v-if="!isAuthenticated"
      class="row"
    >
      <h2>Connectez vous pour profiter de cette plateforme.</h2>
    </div>
  </div>
</template>

<script>
  import store from './../stores';

  export default {
    name: 'Home',
    computed: {
      isAuthenticated() {
        return store.state.auth.isAuthenticated;
      }
    },
    methods: {
      goToSearchByCountry() {
        this.$router.push({ name: 'search-by-country' });
      },
      goToSearchById() {
        this.$router.push({ name: 'search-by-id' });
      },
      goToAdmin() {
        this.$router.push({ name: 'admin-home' });
      },
      goToMyCollection() {
        this.$router.push({ name: 'collection' });
      }
    }
  };
</script>

<style scoped>
    .row {
        justify-content: center;
    }

    .menu-item {
        width: 150px;
        height: 150px;
        border: 1px solid darkorange;
        border-radius: 3px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        text-align: center;
        font-size: 1.4em;
        cursor: pointer;
    }

    .menu-row {
        margin-top: 2em;
        justify-content: space-evenly;
    }

    .col {
        flex: 1;
        justify-content: center;
    }

    .text {
        margin: 0.2em;
    }
</style>
